import { FormProvider as Form, UseFormReturn } from 'react-hook-form';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
  methods: UseFormReturn<any>;
  onSubmit?: VoidFunction;
  autoComplete?: string;
};

export default function FormProvider({ children, onSubmit, methods, autoComplete }: Props) {
  return (
    <Form {...methods}>
      <form autoComplete={autoComplete} onSubmit={onSubmit}>{children}</form>
    </Form>
  );
}
